export default __webpack_public_path__ + "static/media/extra_on.c71ae23f.svg";